import React, { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { getOnlyOneUser } from "redux/actions/servicio-autenticacion/User";
import { compose } from "redux";
import { selectCurrentUser, selectUserLoading } from "redux/selectors/servicio-autenticacion/user.selector";
import { AUTH_TOKEN } from "redux/constants/servicio-autenticacion/Auth";
import jwt_decode from "jwt-decode";

const MODULE_ALIASES = {
  "GESTION DE LICENCIAS": [
    "ADMINISTRACION DE LICENCIAS",
    "ADMINISTRACIÓN DE LICENCIAS",
    "GESTION LICENCIAS",
    "LICENCIAS",
  ],
  "INFORMES DIARIOS": [
    "INFORME DIARIO",
    "INFORME DIARIOS",
    "INFORMES-DIARIOS",
    "INFORMES_DIARIOS",
    "INFORMESDIARIOS",
  ],
  "CONSULTA SIFEN": [
    "CONSULTASIFEN",
    "CONSULTA_SIFEN",
    "CONSULTA-SIFEN",
    "CONSULTAS SIFEN",
    "CONSULTASSIFEN",
    "SIFEN",
  ],
  "CONSULTA RUC": [
    "CONSULTARUC",
    "CONSULTA_RUC",
    "CONSULTA-RUC",
    "RUC",
  ],
};

const normalizeModuleKey = (value = "") =>
  String(value)
    .normalize("NFD")
    .replace(/[\u0300-\u036f]/g, "")
    .toUpperCase()
    .replace(/[^A-Z0-9]/g, "");

/*** Este componente de alto nivel verifica si el usuario tiene acceso al modulo ***/

const withModulos =  (data = false) => (nombreModulo) => (Component) => (props) => {

    let dispatch = useDispatch()

    const currentUser = useSelector(selectCurrentUser)
    const loading = useSelector(selectUserLoading)
    const token = localStorage.getItem(AUTH_TOKEN);
    const decode = token ? jwt_decode(token) : null;
    const currentUserId = decode?.user_id;

    // Trae data del usuario actual
    useEffect(() => {
      if (currentUserId) {
        dispatch(getOnlyOneUser(currentUserId))
      }
    }, [dispatch, currentUserId]);
    
    const modulos = (currentUser?.modulos || []).map((m) =>
      typeof m === "string" ? m : (m?.modulo || m?.name || "")
    )

    const requiredModules = nombreModulo.flatMap((moduleName) => [
      moduleName,
      ...(MODULE_ALIASES[moduleName] || []),
    ])

    const normalizedCurrentModules = modulos.map(normalizeModuleKey)
    const normalizedRequiredModules = requiredModules.map(normalizeModuleKey)

    const isRightModule = () =>
      normalizedRequiredModules.some((requiredModule) =>
        normalizedCurrentModules.includes(requiredModule)
      )

    if (loading) {
      return null;
    }

    if (currentUserId && (!currentUser?._id || currentUser._id !== currentUserId)) {
      return null;
    }
    
    // Si el usuario posee el modulo correcto, renderizar componente
    if (isRightModule()) {
      return <Component {...props} />;
    } else {
      return data ? <h1>Acceso denegado</h1> : null;
    }
};

const withModulosHoc = compose((data, role, Component) => withModulos(data)(role)(Component));

export default withModulosHoc;
